import React from "react";

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8620_40736)">
      <path d="M1.33301 7.99998H14.6663M1.33301 7.99998C1.33301 11.6819 4.31778 14.6666 7.99968 14.6666M1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99968 1.33331M14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99968 14.6666M14.6663 7.99998C14.6663 4.31808 11.6816 1.33331 7.99968 1.33331M7.99968 1.33331C9.6672 3.15888 10.6148 5.528 10.6663 7.99998C10.6148 10.472 9.6672 12.8411 7.99968 14.6666M7.99968 1.33331C6.33216 3.15888 5.38451 5.528 5.33301 7.99998C5.38451 10.472 6.33216 12.8411 7.99968 14.6666" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_8620_40736">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

);

export default GlobeIcon;
